<template> 
<b-form-group align="left">
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label> Hora de Fin:: </label> 
    <vue-timepicker v-model="horaFinal" hide-disabled-items format="HH:mm" 
        close-on-complete></vue-timepicker>
</b-form-group>
</template>

<script>
export default {
    name: "HoraFinal",
    props: { 
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        horaFinal: null,  
    }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: { 
    },
    mounted() { 
    }, 
}
</script>
